import React from 'react';

import './OneValue.scss';

type IOneValue = {
  title: string,
  value: number,
  unit: string,
  className?: string,
  info?: string,
}

const OneValue = ({ title, value, unit, className, info }: IOneValue) => (
  <div className={`one-value ${className}`}>
    <h5>{title}</h5>
    <h2>{value} <span>{unit}</span></h2>
    {info && (<p>{info}</p>)}
  </div>

);

export default OneValue;
